import React, { useState, useEffect } from 'react';
import api from '../utils/api';
import toast from 'react-hot-toast';
import { X } from 'lucide-react';

export default function NuevoEventoModal({ onClose, onCreated }) {
  const [form, setForm] = useState({ tipo_evento_id:'', vehiculo_id:'', cliente_id:'', descripcion:'', prioridad:'media', latitud:'', longitud:'', ubicacion_descripcion:'' });
  const [tiposEvento, setTiposEvento] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [vehiculos, setVehiculos] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    Promise.all([
      api.get('/catalogos/tipos-evento'),
      api.get('/catalogos/clientes?activo=true'),
    ]).then(([te, cl]) => {
      setTiposEvento(te.data.data);
      setClientes(cl.data.data);
    });
  }, []);

  const handleClienteChange = async (clienteId) => {
    setForm(f => ({...f, cliente_id: clienteId, vehiculo_id:''}));
    if (clienteId) {
      const res = await api.get(`/catalogos/vehiculos?cliente_id=${clienteId}&activo=true`);
      setVehiculos(res.data.data);
    } else setVehiculos([]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const body = Object.fromEntries(Object.entries(form).filter(([,v]) => v !== ''));
      await api.post('/eventos', body);
      toast.success('Evento creado correctamente');
      onCreated();
    } catch (err) { toast.error(err.response?.data?.message || 'Error al crear evento'); }
    finally { setLoading(false); }
  };

  return (
    <div className="modal-overlay">
      <div className="modal" style={{ maxWidth: 560 }}>
        <div className="modal-header">
          <span className="modal-title">Nuevo Evento Manual</span>
          <button className="btn-icon" onClick={onClose}><X size={16}/></button>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="modal-body">
            <div className="grid-2">
              <div className="form-group">
                <label className="form-label">Tipo de Evento *</label>
                <select className="form-control" value={form.tipo_evento_id} onChange={e => setForm(f=>({...f, tipo_evento_id:e.target.value}))} required>
                  <option value="">Seleccionar...</option>
                  {tiposEvento.map(t => <option key={t.id} value={t.id}>{t.nombre}</option>)}
                </select>
              </div>
              <div className="form-group">
                <label className="form-label">Prioridad *</label>
                <select className="form-control" value={form.prioridad} onChange={e => setForm(f=>({...f, prioridad:e.target.value}))}>
                  <option value="baja">Baja</option>
                  <option value="media">Media</option>
                  <option value="alta">Alta</option>
                  <option value="critica">Crítica</option>
                </select>
              </div>
              <div className="form-group">
                <label className="form-label">Cliente *</label>
                <select className="form-control" value={form.cliente_id} onChange={e => handleClienteChange(e.target.value)} required>
                  <option value="">Seleccionar...</option>
                  {clientes.map(c => <option key={c.id} value={c.id}>{c.nombre}</option>)}
                </select>
              </div>
              <div className="form-group">
                <label className="form-label">Vehículo</label>
                <select className="form-control" value={form.vehiculo_id} onChange={e => setForm(f=>({...f, vehiculo_id:e.target.value}))}>
                  <option value="">Seleccionar...</option>
                  {vehiculos.map(v => <option key={v.id} value={v.id}>{v.placas} — {v.numero_economico}</option>)}
                </select>
              </div>
            </div>
            <div className="form-group">
              <label className="form-label">Descripción del Evento *</label>
              <textarea className="form-control" value={form.descripcion} onChange={e => setForm(f=>({...f, descripcion:e.target.value}))} required rows={3} placeholder="Describe la alerta o situación..."/>
            </div>
            <div className="form-group">
              <label className="form-label">Ubicación (descripción)</label>
              <input className="form-control" value={form.ubicacion_descripcion} onChange={e => setForm(f=>({...f, ubicacion_descripcion:e.target.value}))} placeholder="Ej: Autopista México-Puebla km 120"/>
            </div>
            <div className="grid-2">
              <div className="form-group">
                <label className="form-label">Latitud</label>
                <input className="form-control" type="number" step="any" value={form.latitud} onChange={e => setForm(f=>({...f, latitud:e.target.value}))} placeholder="19.4326"/>
              </div>
              <div className="form-group">
                <label className="form-label">Longitud</label>
                <input className="form-control" type="number" step="any" value={form.longitud} onChange={e => setForm(f=>({...f, longitud:e.target.value}))} placeholder="-99.1332"/>
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" onClick={onClose}>Cancelar</button>
            <button type="submit" className="btn btn-primary" disabled={loading}>
              {loading ? <span className="spinner" style={{width:14,height:14}}/> : 'Crear Evento'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
